export const allDevicesCheckForAlert = () => {
    if ($('#product-list-items div.alert').length > 0) $('.alert').parent().removeClass('col-md-3').addClass('col-md-6');
};
